var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgICar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 960.0 720.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l960.0 0l0 720.0l-960.0 0l0 -720.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l960.0 0l0 720.0l-960.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m153.19739 486.76697c-65.56136 -154.77478 -2.9528656 -332.16058 147.25009 -417.197c150.20297 -85.03644 342.81326 -52.141113 453.00375 77.367134c110.19055 129.50827 104.81152 316.6681 -12.651001 440.18478c-117.462524 123.51666 -311.67102 146.23132 -456.7627 53.423096l195.96149 -280.54596z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m153.19739 486.76697c-65.56136 -154.77478 -2.9528656 -332.16058 147.25009 -417.197c150.20297 -85.03644 342.81326 -52.141113 453.00375 77.367134c110.19055 129.50827 104.81152 316.6681 -12.651001 440.18478c-117.462524 123.51666 -311.67102 146.23132 -456.7627 53.423096",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 24,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeDasharray: "72.0,96.0,0.0,96.0",
    d: "m153.19739 486.76697c-65.56136 -154.77478 -2.9528656 -332.16058 147.25009 -417.197c150.20297 -85.03644 342.81326 -52.141113 453.00375 77.367134c110.19055 129.50827 104.81152 316.6681 -12.651001 440.18478c-117.462524 123.51666 -311.67102 146.23132 -456.7627 53.423096",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m243.52773 359.99103l0 0c0 -130.59143 105.86528 -236.4567 236.45668 -236.4567l0 0c62.71225 0 122.85593 24.91233 167.20016 69.25655c44.34424 44.34424 69.25653 104.48793 69.25653 167.20015l0 0c0 130.5914 -105.865234 236.45667 -236.4567 236.45667l0 0c-130.5914 0 -236.45668 -105.865265 -236.45668 -236.45667z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 101.91601049868767,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m243.52773 359.99103l0 0c0 -130.59143 105.86528 -236.4567 236.45668 -236.4567l0 0c62.71225 0 122.85593 24.91233 167.20016 69.25655c44.34424 44.34424 69.25653 104.48793 69.25653 167.20015l0 0c0 130.5914 -105.865234 236.45667 -236.4567 236.45667l0 0c-130.5914 0 -236.45668 -105.865265 -236.45668 -236.45667z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m447.3626 359.9938l0 0c0 -18.020996 14.608917 -32.629913 32.629944 -32.629913l0 0c8.653992 0 16.953522 3.4377747 23.072815 9.557068c6.119293 6.1193237 9.557068 14.418854 9.557068 23.072845l0 0c0 18.021027 -14.608887 32.629944 -32.629883 32.629944l0 0c-18.021027 0 -32.629944 -14.608917 -32.629944 -32.629944z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4.246719160104987,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m447.3626 359.9938l0 0c0 -18.020996 14.608917 -32.629913 32.629944 -32.629913l0 0c8.653992 0 16.953522 3.4377747 23.072815 9.557068c6.119293 6.1193237 9.557068 14.418854 9.557068 23.072845l0 0c0 18.021027 -14.608887 32.629944 -32.629883 32.629944l0 0c-18.021027 0 -32.629944 -14.608917 -32.629944 -32.629944z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m463.6741 515.4194l10.707672 -24.472443l11.214569 0l10.707672 24.472443z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 33.971128608923884,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m463.6741 515.4194l10.707672 -24.472443l11.214569 0l10.707672 24.472443z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m391.15317 246.12454l7.738678 26.846222l-3.949768 3.9768372l-26.781036 -7.673462z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 33.971128608923884,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "m391.15317 246.12454l7.738678 26.846222l-3.949768 3.9768372l-26.781036 -7.673462z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m615.4237 420.4409l-20.049255 -17.374481l3.4371338 -10.825836l26.501892 -2.9492798z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 33.971128608923884,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m615.4237 420.4409l-20.049255 -17.374481l3.4371338 -10.825836l26.501892 -2.9492798z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m334.43936 389.23166l26.563751 3.133667l3.3134155 10.709015l-20.23938 17.306915z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 33.971128608923884,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m334.43936 389.23166l26.563751 3.133667l3.3134155 10.709015l-20.23938 17.306915z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m587.96844 268.47556l-24.552612 10.848114l-8.312073 -7.5230103l8.644226 -25.246368z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 33.971128608923884,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m587.96844 268.47556l-24.552612 10.848114l-8.312073 -7.5230103l8.644226 -25.246368z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m447.36328 517.6886l0 0c0 -10.558655 14.608917 -19.118134 32.629944 -19.118134l0 0c18.020996 0 32.629883 8.559479 32.629883 19.118134l0 0c0 10.558655 -14.608887 19.118103 -32.629883 19.118103l0 0c-18.021027 0 -32.629944 -8.559448 -32.629944 -19.118103z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4.246719160104987,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m447.36328 517.6886l0 0c0 -10.558655 14.608917 -19.118134 32.629944 -19.118134l0 0c18.020996 0 32.629883 8.559479 32.629883 19.118134l0 0c0 10.558655 -14.608887 19.118103 -32.629883 19.118103l0 0c-18.021027 0 -32.629944 -8.559448 -32.629944 -19.118103z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m614.7045 437.7583l0 0c-10.010742 -3.4006958 -13.458496 -19.990814 -7.7008057 -37.055115l0 0c5.7576904 -17.0643 18.540466 -28.140839 28.551208 -24.740173l0 0c10.010681 3.4006958 13.458435 19.990845 7.7007446 37.055115l0 0c-5.7576904 17.0643 -18.540466 28.140839 -28.551147 24.740173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4.246719160104987,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m614.7045 437.7583l0 0c-10.010742 -3.4006958 -13.458496 -19.990814 -7.7008057 -37.055115l0 0c5.7576904 -17.0643 18.540466 -28.140839 28.551208 -24.740173l0 0c10.010681 3.4006958 13.458435 19.990845 7.7007446 37.055115l0 0c-5.7576904 17.0643 -18.540466 28.140839 -28.551147 24.740173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m601.4983 277.8275l0 0c-7.4623413 7.462372 -23.840942 3.1826477 -36.58264 -9.5590515l0 0c-12.741699 -12.741684 -17.021423 -29.1203 -9.559082 -36.582672l0 0c7.4624023 -7.462372 23.841003 -3.1826324 36.582703 9.5590515l0 0c12.741699 12.741684 17.021423 29.1203 9.559021 36.582672z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4.246719160104987,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m601.4983 277.8275l0 0c-7.4623413 7.462372 -23.840942 3.1826477 -36.58264 -9.5590515l0 0c-12.741699 -12.741684 -17.021423 -29.1203 -9.559082 -36.582672l0 0c7.4624023 -7.462372 23.841003 -3.1826324 36.582703 9.5590515l0 0c12.741699 12.741684 17.021423 29.1203 9.559021 36.582672z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m400.51303 231.68704l0 0c7.462372 7.4623566 3.1826477 23.840988 -9.5590515 36.582672l0 0c-12.741699 12.741699 -29.1203 17.021423 -36.582672 9.5590515l0 0c-7.462372 -7.462372 -3.1826477 -23.840988 9.5590515 -36.582672l0 0c12.741699 -12.741684 29.1203 -17.021423 36.582672 -9.5590515z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4.246719160104987,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m400.51303 231.68704l0 0c7.462372 7.4623566 3.1826477 23.840988 -9.5590515 36.582672l0 0c-12.741699 12.741699 -29.1203 17.021423 -36.582672 9.5590515l0 0c-7.462372 -7.462372 -3.1826477 -23.840988 9.5590515 -36.582672l0 0c12.741699 -12.741684 29.1203 -17.021423 36.582672 -9.5590515z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m325.0266 375.83005l0 0c10.045471 -3.2528076 22.708435 8.0 28.283447 25.13385l0 0c5.5750427 17.13388 1.9510193 33.660583 -8.094482 36.91339l0 0c-10.045502 3.2528381 -22.708435 -7.9999695 -28.283478 -25.13385l0 0c-5.575012 -17.13388 -1.9509888 -33.660553 8.094513 -36.91339z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4.246719160104987,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m325.0266 375.83005l0 0c10.045471 -3.2528076 22.708435 8.0 28.283447 25.13385l0 0c5.5750427 17.13388 1.9510193 33.660583 -8.094482 36.91339l0 0c-10.045502 3.2528381 -22.708435 -7.9999695 -28.283478 -25.13385l0 0c-5.575012 -17.13388 -1.9509888 -33.660553 8.094513 -36.91339z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICar);
export default __webpack_public_path__ + "static/media/ICar.3db3fa7dbd4f2074533dd9c47a302900.svg";
export { ForwardRef as ReactComponent };